/**
 * Orderopatorio
 *
 * The version of the OpenAPI document: 0.15.6-SNAPSHOT
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export const Unit = {
  Piece: 'PIECE',
  Gram: 'GRAM',
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type Unit = typeof Unit[keyof typeof Unit];
